<section>
  <h6 class="uk-flex uk-flex-middle"><span class="material-symbols-outlined uk-margin-small-right">settings</span>Main info settings</h6>
  <ul data-uk-accordion="multiple: true">
    <li class="uk-open">
      <a class="uk-accordion-title uk-text-normal uk-text-default" href>Advanced</a>
      <div class="uk-accordion-content">
        <div class="uk-margin">
          <div for="placeholder" class="uk-margin-small-bottom uk-text-muted">Model id</div>
<!--          <label for="placeholder" class="uk-text-muted uk-text-bold">Model id</label>-->
          <input id="placeholder" type="text" class="uk-input" [ngModel]="$safeNavigationMigration(fbService.model()?.id)"
                 (ngModelChange)="fbService.setModelId($event)">
        </div>
        <div>
          <div class="uk-text-muted uk-text-bold">
            <input id="locked" class="uk-checkbox" type="checkbox" [ngModel]="$safeNavigationMigration(fbService.model()?.locked)"
                   (ngModelChange)="fbService.setModelLocked($event)">
            <label for="locked" class="uk-checkbox-label uk-margin-small-left">Locked</label>
          </div>

          <div class="uk-text-muted uk-text-bold">
            <input id="active" class="uk-checkbox" type="checkbox" [ngModel]="$safeNavigationMigration(fbService.model()?.active)"
                   (ngModelChange)="fbService.setModelActive($event)">
            <label for="active" class="uk-checkbox-label uk-margin-small-left">Active</label>
          </div>
        </div>
      </div>
    </li>
  </ul>
</section>
